import React from "react";
import "./WtPrev10.css";

const WtPrev10 = (props) => {
  const wpcBtn = () => {
    // HARD GUARANTEES (NO undefined)
    const mobile = String(props.mobile_no || "").trim();
    if (!mobile) {
      console.error("WtPrev10: mobile_no is missing");
      return;
    }

    const message =
      typeof props.prefilledmsg === "string" && props.prefilledmsg.trim() !== ""
        ? props.prefilledmsg
        : "hi";

    const url = `https://wa.me/${mobile}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="authkey-m-d10"
      style={{
        [props.position || "right"]: `${props.sidemargin ?? 20}px`,
        bottom: `${props.marginbottom ?? 80}px`,
      }}
    >
      <button
        type="button"
        id="send-button"
        className="authkey-whatsappChatBtnPreview10"
        onClick={wpcBtn}
      >
        <svg
          viewBox="0 0 24 24"
          className="authkey-whatsappChatIconPreview10"
          aria-hidden="true"
        >
          <path
            d="M21 11.5a8.38 8.38 0 0 1-1.9 5.4
               8.5 8.5 0 0 1-6.6 3.1
               8.38 8.38 0 0 1-3.9-.9
               L3 21l1.4-4.1
               a8.38 8.38 0 0 1-.9-3.9
               8.5 8.5 0 0 1 3.1-6.6
               8.38 8.38 0 0 1 5.4-1.9h.5
               a8.48 8.48 0 0 1 8 8z"
          />
        </svg>
        Chat on WhatsApp
      </button>
    </div>
  );
};

export default WtPrev10;
